/**
 * Simple Prev/Next pager for a Spring Data Page response.
 * `page` is 0-indexed (matches Spring's Pageable), `totalPages`/`totalElements` come straight off the Page JSON.
 */
const Pagination = ({ page, totalPages, totalElements, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "10px",
        marginTop: "14px",
        padding: "6px 2px",
      }}
    >
      <span className="page-subtitle">
        Page {page + 1} of {totalPages}
        {typeof totalElements === "number" ? ` · ${totalElements} total` : ""}
      </span>
      <div style={{ display: "flex", gap: "8px" }}>
        <button type="button" className="secondary" disabled={page <= 0} onClick={() => onPageChange(page - 1)}>
          Previous
        </button>
        <button type="button" className="secondary" disabled={page >= totalPages - 1} onClick={() => onPageChange(page + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
